import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Header.js";
import api from "../../api/axios.js";
import useUser from "../../hook/useUser.js";

const EmployeeFeedbackView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useUser();

  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    if (!user) return;

    api
      .get("/api/feedback/" + user.employeeId + "/" + id)
      .then((res) => {
        console.log("SUCCESS:", res.data);
        setFeedback(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, id]);

  if (!user) return <p>Loading...</p>;
  if (!feedback) return <p>Loading...</p>;

  return (
    <div className="dashboard-wrapper">
      <Header />

      <div className="employee-feedback-view-wrap">
        <button
          className="employee-feedback-close"
          onClick={() => navigate("/quiz/main")}
          aria-label="Close feedback"
        >
          <img src="/images/close-window-dark.png" alt="close" />
        </button>
        <p className="employee-feedback-view-title">Feedback from manager</p>
        <p className="employee-feedback-view-subtitle">Your feedback on {feedback.quizTitle}</p>

      <div className="employee_feedback_view">
        <textarea
          className="employee_feedback_box"
          value={feedback.message}
          readOnly
        />
        </div>
      </div>
    </div>
  );
};

export default EmployeeFeedbackView;